function toggleAttribute(element, attributeName, trueValue, falseValue) {
  const currentValue = element.getAttribute(attributeName);
  element.setAttribute(attributeName, currentValue === trueValue ? falseValue : trueValue);
}

function toggleClass(element, className) {
  element.classList.toggle(className);
}

function clickIfExists(element) {
  if (element) {
    element.click();
  }
}

class MenuManager {
  constructor() {
    this.bodyElement = document.querySelector('body');
    this.searchElement = document.querySelector('#Search');
    this.menuBtn = document.querySelector('.menu-btn');
    this.menuCart = document.querySelector('#menu-cart');
    this.mainElement = document.querySelector('main');
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupMainFocusListener();

    const closeButton = document.querySelector('button[data-action="close-drawer"]');

    closeButton.addEventListener('click', () => {
      if (document.body.classList.contains('cart-open')) {
        document.body.classList.remove('cart-open');
      }
    });
  }

  setupEventListeners() {
    this.menuBtn.addEventListener('click', this.toggleMenu.bind(this));
    this.menuCart.addEventListener('click', this.openCart.bind(this));
    document.addEventListener('keydown', this.handleKeydown.bind(this));
    const toggleSearchElements = document.querySelectorAll('[data-action="toggle-search"]');
    toggleSearchElements.forEach(element => element.addEventListener('click', this.toggleSearch.bind(this)));
  }

  toggleSearch() {
    if (this.bodyElement.classList.contains('search-open')) {
      this.closeSearch();
    } else {
      this.openSearch();
    }
  }

  openSearch() {
    this.searchElement.setAttribute('aria-hidden', 'false');
    this.searchElement.tabIndex = 0;
    this.closeMenu();
    this.closeCart();
    this.bodyElement.classList.add("search-open", "no-scroll");
    this.checkAndAdjustEmptySuggestions();
  }

  closeSearch() {
    this.searchElement.setAttribute('aria-hidden', 'true');
    this.searchElement.tabIndex = -1;
    this.bodyElement.classList.remove('search-open', 'no-scroll');
  }

  toggleAttribute(element, attributeName, trueValue, falseValue) {
    const currentValue = element.getAttribute(attributeName);
    element.setAttribute(attributeName, currentValue === trueValue ? falseValue : trueValue);
  }

  checkAndAdjustEmptySuggestions() {
    const suggestions = this.searchElement.querySelectorAll('.Search--Suggestions ul');
    suggestions.forEach(ul => {
      if (ul.children.length === 0) {
        ul.parentElement.style.display = 'none';
      } else {
        ul.parentElement.style.removeProperty('display');
      }
    });
  }

  toggleMenu() {
    if (this.bodyElement.classList.contains('menu-open')) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }
    
  openMenu() {
    this.closeSearch();
    this.closeCart();
    this.bodyElement.classList.add('menu-open');
    this.menuBtn.classList.add('is-active');
    this.menuBtn.setAttribute('aria-expanded', 'true');
  
    // Search `.nav-list` for any <a> only in visible top-level list items and set the tabindex to 0
    const topLinks = this.bodyElement.querySelectorAll('.nav-list > .nav-list__item > a');
    topLinks.forEach(link => {
      link.tabIndex = 0;
    });
  }

  
  closeMenu() {
    this.bodyElement.classList.remove('menu-open');
    this.menuBtn.classList.remove('is-active');
    this.menuBtn.setAttribute('aria-expanded', 'false');
    
    // Search `.nav-list` for any <a> and set the tabindex to -1
    const links = this.bodyElement.querySelectorAll('.nav-list a');
    links.forEach(link => {
      link.tabIndex = -1;
    });
  }

  openCart() {
    this.closeSearch();
    this.closeMenu();
    this.bodyElement.classList.add("cart-open");
    this.toggleAttribute(this.menuBtn, 'aria-expanded', 'false', 'true');
    const controlledElement = document.getElementById(this.menuBtn.getAttribute('aria-controls'));
    if (controlledElement) controlledElement.setAttribute('aria-hidden', 'false');
    if (this.menuCart) this.menuCart.classList.add("is-open");
  }

  closeCart() {
    this.bodyElement.classList.remove("cart-open");
    this.toggleAttribute(this.menuBtn, 'aria-expanded', 'true', 'false');
    const controlledElement = document.getElementById(this.menuBtn.getAttribute('aria-controls'));
    if (controlledElement) controlledElement.setAttribute('aria-hidden', 'true');
    this.closeDrawer();
    this.bodyElement.classList.remove("cart-open");
  }

  closeDrawer() {
    const closeButton = document.querySelector('button[data-action="close-drawer"]');
    if (closeButton) {
      closeButton.click();
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      if (this.bodyElement.classList.contains('menu-open')) {
        this.closeMenu();
        this.closeSearch();
        this.closeCart();
        this.bodyElement.classList.remove("cart-open");
      }
      if (this.bodyElement.classList.contains('search-open')) {
        this.closeMenu();
        this.closeSearch();
        this.closeCart();
        this.bodyElement.classList.remove("cart-open");
      }
      if (this.bodyElement.classList.contains('cart-open')) {
        this.closeMenu();
        this.closeSearch();
        this.closeCart();
        this.bodyElement.classList.remove("cart-open");
      }
    } else if (event.key === 'Enter' && event.target === this.menuBtn) {
      this.toggleMenu();
    }
  }

  setupMainFocusListener() {
    this.mainElement.addEventListener('focusin', () => {
      this.closeMenu();
      this.closeSearch();
      this.closeCart();
      this.bodyElement.classList.remove("cart-open");
    }, true);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  try {
    new MenuManager();
  } catch (error) {
    console.error('An error occurred while initializing the UI controller:', error);
  }
});

function addSectionBreaks() {
    const navItems = document.querySelectorAll('.nav-list__item');

    navItems.forEach(item => {
        const link = item.querySelector('a');
        if (link && (link.href.includes('/account') || link.href.includes('/pages/our-saga'))) {
            const sectionBreak = document.createElement('li');
            sectionBreak.className = 'section-break';
            item.parentNode.insertBefore(sectionBreak, item);
        }
    });
}

function setHeaderHeight() {
    const headerContainer = document.querySelector('.header-container--wrapper');
    if (!headerContainer) return;
    const headerHeight = headerContainer.offsetHeight;
    document.body.style.setProperty('--header-height', `${headerHeight}px`);
}

function handleNavHover() {
    const parentItems = document.querySelectorAll('.nav-item[data-img]');
    const navFigureImg = document.querySelector('.nav-figure img');
    const currentURL = window.location.href;
    const menuBtn = document.querySelector('.menu-btn');

    parentItems.forEach(item => {
        const dataImg = item.getAttribute('data-img');
        const itemURL = item.href;
        const subList = item.nextElementSibling;

        if (dataImg && navFigureImg && itemURL === currentURL) {
            menuBtn.addEventListener('click', () => {
                navFigureImg.style.opacity = 0;
                setTimeout(() => {
                    navFigureImg.src = dataImg;
                    navFigureImg.style.opacity = 1;
                }, 150);

                item.classList.add('is-active');
                item.closest(".nav-list__item").classList.add('is-active');
                item.closest(".nav-list__sub").setAttribute('aria-expanded', 'true');
                item.closest(".nav-list__sub").setAttribute('aria-hidden', 'false');

                if (subList) {
                    subList.setAttribute('aria-expanded', 'true');
                    subList.setAttribute('aria-hidden', 'false');
                    // Set all <a> links inside the sublink to tabindex -1
                    subList.querySelectorAll('a').forEach(link => {
                        link.tabIndex = -1;
                    });
                }
            });

            item.classList.add('is-active');
            item.closest(".nav-list__item").classList.add('is-active');

            if (item.closest(".nav-list__sub")) {
                item.closest(".nav-list__sub").setAttribute('aria-expanded', 'true');
                item.closest(".nav-list__sub").setAttribute('aria-hidden', 'false');

                if (subList) {
                    subList.setAttribute('aria-expanded', 'true');
                    subList.setAttribute('aria-hidden', 'false');
                    // Set all <a> links inside the sublink to tabindex 0
                    subList.querySelectorAll('a').forEach(link => {
                        link.tabIndex = 0;
                    });
                }
            }
        }
    });
}

function removeEmptyParagraphs() {
  const gridHeaders = document.querySelectorAll('.grid-header');
  if (!gridHeaders) return;

  gridHeaders.forEach((header) => {
    const paragraphs = header.querySelectorAll('p');

    paragraphs.forEach((paragraph) => {
      if (paragraph.textContent.trim() === '') {
        paragraph.remove();
      }
    });
  });
}

function hideDefaultTitles() {
    const spans = document.querySelectorAll('.product-meta__title p span');
    const regex = /default title/i;

    if (spans.length > 0) {
        spans.forEach(span => {
            if (regex.test(span.innerText)) {
                const parentParagraph = span.closest('.product-meta__title p');
                parentParagraph.remove();
            }
        });
    } else {}
}

function hideDefaultValue() {
    const spans = document.querySelectorAll('.sale-price span');

    if (spans.length > 0) {
        spans.forEach(span => {
            if (span.innerText.includes('value')) {
                span.innerText = span.innerText.replace('value ', '');
            }
        });
    }
}

const SiteNav = {
    init: function() {
        setHeaderHeight();
        window.addEventListener('resize', setHeaderHeight);

        let jsonData;
        
        const jsonDataElement = document.getElementById('json-data');
        if (jsonDataElement) {
          jsonData = JSON.parse(jsonDataElement.textContent);
        }

        let navList = document.querySelector('.nav-list');

        if (jsonData != undefined) {
          jsonData.forEach(item => {
            let listItem = document.createElement('li');
            listItem.className = 'nav-list__item';

            let link = document.createElement('a');
            link.setAttribute('tabindex', '-1');

            if (item.url) {
              link.href = item.url;
              
            } else {
              link.setAttribute('role', 'button');
            }

            if (item.img) {
                try {
                    link.setAttribute("data-img", item.img);
                } catch (error) {
                    console.error('Error setting data-img attribute:', error);
                }
            } else if (item.children && item.children.length > 0 && item.children[0].img) {
                try {
                    link.setAttribute("data-img", item.children[0].img);
                } catch (error) {
                    console.error('Error setting data-img attribute from children:', error);
                }
            }

            link.className = 'nav-item';
            link.textContent = item.name;

            listItem.appendChild(link);

            if (item.children && item.children.length > 0) {
                listItem.classList.add('nav-list__parent');
                link.classList.add('nav-item__parent');
            }

            if (item.children && item.children.length > 0) {
                let subList = document.createElement('ul');
                subList.className = 'nav-list__sub';
                subList.setAttribute('aria-expanded', 'false');

                item.children.forEach(child => {
                    let childListItem = document.createElement('li');
                    let childLink = document.createElement('a');

                    if (child.img) {
                        try {
                            childLink.setAttribute("data-img", child.img);
                        } catch (error) {
                            console.error('Error setting data-img attribute for child:', error);
                        }
                    }

                    childLink.href = child.url;
                    childLink.className = 'nav-item nav-item__child';
                    childLink.textContent = child.name;
                    childLink.tabIndex = -1;

                    childListItem.appendChild(childLink);
                    subList.appendChild(childListItem);
                });

                listItem.appendChild(subList);
            }

            navList.appendChild(listItem);
        });
        }

   document.addEventListener('DOMContentLoaded', (event) => {
        const parentLinks = document.querySelectorAll('.nav-item__parent');
    
        if (parentLinks) {
            parentLinks.forEach(link => {
                link.tabIndex = -1;
                const parentItem = link.closest('.nav-list__parent');
                const subList = parentItem.querySelector('.nav-list__sub');
    
                const toggleSubList = (e) => {
                    e.preventDefault(); // Prevent default action if necessary
                    const isActive = parentItem.classList.contains('is-active');
    
                    if (isActive) {
                        subList.setAttribute('aria-expanded', 'false');
                        parentItem.classList.remove('is-active');
                        // Optional: Update tabIndex for all <a> in this sublist to -1 for accessibility
                        subList.querySelectorAll('a').forEach(a => a.tabIndex = -1);
                    } else {
                        const allParents = document.querySelectorAll('.nav-list__parent');
                        allParents.forEach(parent => {
                            const sub = parent.querySelector('.nav-list__sub');
                            if (parent !== parentItem) {
                                sub.setAttribute('aria-expanded', 'false');
                                parent.classList.remove('is-active');
                                // Optional: Update tabIndex for all <a> in these sublists to -1 for accessibility
                                sub.querySelectorAll('a').forEach(a => a.tabIndex = -1);
                            }
                        });
    
                        subList.setAttribute('aria-expanded', 'true');
                        parentItem.classList.add('is-active');
                        // Update tabIndex for all <a> in this sublist to 0 for accessibility
                        subList.querySelectorAll('a').forEach(a => a.tabIndex = 0);
                    }
                };
    
                // Click event
                link.addEventListener('click', toggleSubList);
    
                // Keydown event for Enter key
                link.addEventListener('keydown', (e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggleSubList(e);
                  }
                });
            });
        }
    
        handleNavHover();
    });



        addSectionBreaks();



        const newGridItems = document.querySelectorAll('.grid-item');
        if (newGridItems) {
            newGridItems.forEach(function(gridItem) {
                const featuredImage = gridItem.querySelector('.featured-image');
                const secondImage = gridItem.querySelector('.second-image');

                if (secondImage && featuredImage.offsetHeight < 700) {
                    gridItem.addEventListener('mouseover', function() {
                        featuredImage.classList.add('hidden');
                        secondImage.classList.add('visible');
                    });

                    gridItem.addEventListener('mouseout', function() {
                        featuredImage.classList.remove('hidden');
                        secondImage.classList.remove('visible');
                    });
                }
            });
        }

        hideDefaultTitles();
        hideDefaultValue();
        removeEmptyParagraphs();

    },
};
SiteNav.init();

function addStyleToLongParagraphs() {
  const gridHeaders = document.querySelectorAll('.grid-header');

  gridHeaders.forEach(gridHeader => {
    const nodes = gridHeader.getElementsByTagName('p');
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      const words = node.innerText.split(' ');

      if (words.length > 15) {
        node.style.textTransform = 'none';
      }
    }
  });
}

// addStyleToLongParagraphs();


// --------------------------------------------------
// Product Gallery
// --------------------------------------------------

function setThumbnailsMaxHeight() {
  try {
    const productWrapper = document.querySelector('.sproduct-wrapper');
    const thumbnailsContainer = document.querySelector('.sproduct-gallery--thumbnails');
    const screenWidth = window.innerWidth;

    // Check if both productWrapper and thumbnailsContainer elements exist, and if the screen width is more than 1024
    if (productWrapper && thumbnailsContainer && screenWidth > 1024) {
      const productWrapperHeight = productWrapper.offsetHeight;
      thumbnailsContainer.style.maxHeight = `${productWrapperHeight}px`;
    } else if (thumbnailsContainer) {  // Make sure thumbnailsContainer exists before resetting max-height
      thumbnailsContainer.style.maxHeight = ''; // Reset max-height if condition is not met
    }
  } catch (error) {
    console.error('An error occurred while setting thumbnails max height:', error);
  }
}

function initializeProductGallery() {
  const thumbnailsContainer = document.querySelector('.sproduct-gallery--thumbnails');
  const previewImage = document.querySelector('.sproduct-gallery--preview img');

  if (thumbnailsContainer && previewImage) {
    const thumbnails = thumbnailsContainer.querySelectorAll('a');

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', (event) => {
        event.preventDefault(); // Prevent default link behavior

        const clickedThumbnail = event.target.querySelector('img');
        if (clickedThumbnail) {
          const thumbnailSrc = clickedThumbnail.getAttribute('src');
          const thumbnailAlt = clickedThumbnail.getAttribute('alt');

          previewImage.setAttribute('src', thumbnailSrc);
          previewImage.setAttribute('alt', thumbnailAlt);

          // Toggle the "is-active" class on the preview image
          previewImage.classList.toggle('is-active');
          previewImage.style.opacity = '0';
        }
      });
    });

    thumbnailsContainer.addEventListener('keydown', (event) => {
      const activeThumbnail = thumbnailsContainer.querySelector('[aria-current="true"]');
      const currentIndex = Array.from(thumbnails).indexOf(activeThumbnail);
      let nextIndex;

      if (event.code === 'ArrowLeft') {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : thumbnails.length - 1;
      } else if (event.code === 'ArrowRight') {
        nextIndex = currentIndex < thumbnails.length - 1 ? currentIndex + 1 : 0;
      } else {
        return; // Exit early for non-arrow key presses
      }

      event.preventDefault(); // Prevent scrolling on arrow key press

      activeThumbnail.setAttribute('aria-current', 'false');
      thumbnails[nextIndex].setAttribute('aria-current', 'true');
      thumbnails[nextIndex].focus();

      const thumbnailSrc = thumbnails[nextIndex].getAttribute('src');
      const thumbnailAlt = thumbnails[nextIndex].getAttribute('alt');

      previewImage.setAttribute('src', thumbnailSrc);
      previewImage.setAttribute('alt', thumbnailAlt);

      // Toggle the "is-active" class on the preview image
      previewImage.classList.toggle('is-active');
      previewImage.style.opacity = '0';
    });

    // Set initial aria-current state on the first thumbnail
    const initialThumbnail = thumbnailsContainer.querySelector('a');
    if (initialThumbnail) {
      initialThumbnail.setAttribute('aria-current', 'true');

      // Programmatically click on the first thumbnail to display the first image
      initialThumbnail.click();
    }

    // Add "is-active" class 200ms after the image has loaded
    previewImage.addEventListener('load', () => {
      setTimeout(() => {
        previewImage.style.opacity = '1';
        previewImage.classList.add('is-active');
      }, 200);
    });
  } else {
    // console.error('Failed to initialize product gallery. Thumbnails container or preview image not found.');
  }
}

// --------------------------------------------------
// Product Tabs
// --------------------------------------------------
function initializeProductTabs() {
  try {
    const tabHeaders = document.querySelectorAll('.sproduct-tab--header');
    const tabContentSections = document.querySelectorAll('.sproduct-tab--content');

    tabContentSections.forEach((content, index) => {
      if (index !== 0) {
        content.style.display = 'none';
        content.setAttribute('tabindex', '-1');
      } else {
        content.style.display = 'block';
        content.removeAttribute('tabindex');
      }
    });

    function switchTab(index) {
      tabHeaders.forEach((header, idx) => {
        const content = document.getElementById(header.getAttribute('data-controls'));
        if (idx !== index) {
          header.setAttribute('data-selected', 'false');
          content.style.display = 'none';
          content.setAttribute('tabindex', '-1');
        } else {
          header.setAttribute('data-selected', 'true');
          content.style.display = 'block';
          content.removeAttribute('tabindex');
        }
      });
    }

    tabHeaders.forEach((tabHeader, index) => {
      tabHeader.addEventListener('click', (event) => {
        event.preventDefault();
        switchTab(index);
      });

      tabHeader.addEventListener('keydown', (event) => {
        if (event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          switchTab(index);
        }
      });
    });
  } catch (error) {
    console.error('An error occurred while initializing product tabs:', error);
  }
}

function activateFirstTabIfExists() {
  try {
    const tabHeaders = document.querySelectorAll('.sproduct-tab--header');

    if (tabHeaders.length > 0) {
      tabHeaders[0].click();
    }
  } catch (error) {
    console.error('An error occurred while activating the first tab:', error);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  initializeProductTabs();
  setTimeout(activateFirstTabIfExists, 2000);
});

const productDescription = document.querySelector('.sproduct-meta--description');
if (productDescription) {
  const descriptionText = productDescription.innerHTML.trim();
  const sentences = descriptionText.split('<br>').filter(sentence => sentence.trim() !== '');

  const wrappedSentences = sentences.map(sentence => `<p>${sentence}</p>`).join('');

  productDescription.innerHTML = wrappedSentences;
}

// --------------------------------------------------
// Read more
// --------------------------------------------------

function handleProductDescription() {
  try {
    const descriptionElement = document.querySelector('.sproduct-meta--description');

    if (descriptionElement) {
      const paragraphs = descriptionElement.querySelectorAll('p');

      if (paragraphs.length > 2) {
        const firstParagraph = paragraphs[0];
        const remainingParagraphs = Array.from(paragraphs).slice(1);

        // Check if the paragraph is already collapsed
        if (remainingParagraphs[0].style.display === 'none') {
          return; // Return early if already collapsed
        }

        remainingParagraphs.forEach((paragraph) => {
          paragraph.style.display = 'none';
        });

        const readMoreLink = document.createElement('a');
        readMoreLink.textContent = 'Read more';
        readMoreLink.addEventListener('click', () => {
          remainingParagraphs.forEach((paragraph) => {
            paragraph.style.display = 'block';
          });
          readMoreLink.parentNode.remove();
        });

        const readMoreParagraph = document.createElement('p');
        readMoreParagraph.appendChild(readMoreLink);

        descriptionElement.appendChild(readMoreParagraph);
      }
    }
  } catch (error) {
    console.error('An error occurred while handling the product description:', error);
  }
}
document.addEventListener('DOMContentLoaded', function() {
  handleProductDescription();
});

// function updateProductVariant() {
//   try {
//     const variantsBtn = document.querySelector('#variants--btn');
    
//     if (variantsBtn) {
//       const variantText = variantsBtn.querySelector('span')?.textContent;
//       // const sproductVariant = document.querySelector('.sproduct-variant');
//       // if (sproductVariant) {
//       //   sproductVariant.textContent = variantText;
//       // }
//     }
//   } catch (error) {
//     console.error('An error occurred while updating product variant:', error);
//   }
// }

// updateProductVariant();

function checkGalleryThumbnails() {
  const gallery = document.querySelector('.sproduct-gallery');
  if (!gallery) {
    return;
  }

  const thumbnails = gallery.querySelectorAll('.sproduct-gallery--thumbnails ul li');
  if (thumbnails.length <= 3) {
    return;
  }

    const windowWidth = window.innerWidth;
  if (windowWidth <= 1299) {
    return;
  }

  const productWrapper = document.querySelector('.sproduct-wrapper');
  const thumbnailsList = gallery.querySelector('.sproduct-gallery--thumbnails ul');

  const productWrapperHeight = productWrapper.offsetHeight;

  let totalThumbnailsHeight = 0;
  thumbnails.forEach((thumbnail) => {
    totalThumbnailsHeight += thumbnail.offsetHeight;
  });

  if (totalThumbnailsHeight > productWrapperHeight) {
    const slideDownArrow = document.createElement('div');
    slideDownArrow.className = 'slide-down-arrow';
    slideDownArrow.setAttribute('role', 'button');
    slideDownArrow.setAttribute('aria-expanded', 'false');
    slideDownArrow.setAttribute('aria-label', 'Expand thumbnails');
    slideDownArrow.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
        <path d="M 4.21875 10.78125 L 2.78125 12.21875 L 15.28125 24.71875 L 16 25.40625 L 16.71875 24.71875 L 29.21875 12.21875 L 27.78125 10.78125 L 16 22.5625 Z" fill="currentColor"/>
      </svg>
    `;
    thumbnailsList.insertAdjacentElement('afterend', slideDownArrow);

    const slideUpArrow = document.createElement('div');
    slideUpArrow.className = 'slide-up-arrow';
    slideUpArrow.setAttribute('role', 'button');
    slideUpArrow.setAttribute('aria-expanded', 'false');
    slideUpArrow.setAttribute('aria-label', 'Collapse thumbnails');
    slideUpArrow.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
        <path d="M 16 6.59375 L 15.28125 7.28125 L 2.78125 19.78125 L 4.21875 21.21875 L 16 9.4375 L 27.78125 21.21875 L 29.21875 19.78125 L 16.71875 7.28125 Z" fill="currentColor"/>
      </svg>
    `;
    thumbnailsList.insertAdjacentElement('beforebegin', slideUpArrow);

    function updateScrollArrows() {
      const maxScrollPosition = totalThumbnailsHeight - productWrapperHeight - 1;
      slideDownArrow.style.opacity = thumbnailsList.scrollTop >= maxScrollPosition ? 0 : 1;
      slideUpArrow.style.opacity = thumbnailsList.scrollTop === 0 ? 0 : 1;
    }

    slideDownArrow.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);

      if (!isExpanded) {
        const visibleThumbnails = Math.floor(productWrapperHeight / thumbnails[0].offsetHeight);
        const currentScrollPosition = thumbnailsList.scrollTop;
        const newScrollPosition = currentScrollPosition + thumbnails[0].offsetHeight;
        const maxScrollPosition = totalThumbnailsHeight - productWrapperHeight;

        if (newScrollPosition < maxScrollPosition) {
          thumbnailsList.scrollTo({ top: newScrollPosition, behavior: 'smooth' });
        } else {
          thumbnailsList.scrollTo({ top: maxScrollPosition, behavior: 'smooth' });
        }
      }
    });

   slideUpArrow.addEventListener('click', function() {
      const isExpanded = slideDownArrow.getAttribute('aria-expanded') === 'true';
      slideDownArrow.setAttribute('aria-expanded', !isExpanded);

      if (thumbnailsList.scrollTop > 0) {
        const currentScrollPosition = thumbnailsList.scrollTop;
        const newScrollPosition = currentScrollPosition - thumbnails[0].offsetHeight;

        if (newScrollPosition > 0) {
          thumbnailsList.scrollTo({ top: newScrollPosition, behavior: 'smooth' });
        } else {
          thumbnailsList.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    });

    thumbnailsList.addEventListener('scroll', updateScrollArrows);
    updateScrollArrows();

  }
}

function addPreviewArrows() {
  const preview = document.querySelector('.sproduct-gallery--preview');
  if (!preview) {
    return;
  }

  const windowWidth = window.innerWidth;
  if (windowWidth >= 1300) {
    return;
  }

  const thumbnails = document.querySelectorAll('.sproduct-gallery--thumbnails li');
  if (thumbnails.length <= 2) {
    return;
  }

  const leftArrow = document.createElement('div');
  leftArrow.className = 'preview-arrow left-arrow';
  leftArrow.innerHTML = '';
  preview.appendChild(leftArrow);

  const rightArrow = document.createElement('div');
  rightArrow.className = 'preview-arrow right-arrow';
  rightArrow.innerHTML = '';
  preview.appendChild(rightArrow);

  const paginationNav = document.querySelector('.sproduct-pagination'); // Get the dot pagination nav element
  const paginationLinks = paginationNav.querySelectorAll('a'); // Get the pagination links

  const currentThumbnail = document.querySelector('.sproduct-gallery--thumbnails li a[aria-current="true"]');
  let currentIndex = Array.from(thumbnails).indexOf(currentThumbnail.parentElement);

  leftArrow.addEventListener('click', function() {
    if (currentIndex === 0) {
      return;
    }

    currentIndex--;
    const prevThumbnail = thumbnails[currentIndex];
    prevThumbnail.querySelector('a').click();
    paginationLinks[currentIndex].click(); // Trigger click on corresponding pagination link
  });

  rightArrow.addEventListener('click', function() {
    if (currentIndex === thumbnails.length - 1) {
      return;
    }

    currentIndex++;
    const nextThumbnail = thumbnails[currentIndex];
    nextThumbnail.querySelector('a').click();
    paginationLinks[currentIndex].click(); // Trigger click on corresponding pagination link
  });

  let touchStartX = 0;
  let touchEndX = 0;

  preview.addEventListener('touchstart', function(event) {
    touchStartX = event.touches[0].clientX;
  });

  preview.addEventListener('touchend', function(event) {
    touchEndX = event.changedTouches[0].clientX;
    handleSwipeGesture();
  });

  function handleSwipeGesture() {
    const swipeThreshold = 50;
    const deltaX = touchEndX - touchStartX;

    if (deltaX > swipeThreshold) {
      // Swipe right
      if (currentIndex > 0) {
        currentIndex--;
        const prevThumbnail = thumbnails[currentIndex];
        prevThumbnail.querySelector('a').click();
        paginationLinks[currentIndex].click(); // Trigger click on corresponding pagination link
      }
    } else if (deltaX < -swipeThreshold) {
      // Swipe left
      if (currentIndex < thumbnails.length - 1) {
        currentIndex++;
        const nextThumbnail = thumbnails[currentIndex];
        nextThumbnail.querySelector('a').click();
        paginationLinks[currentIndex].click(); // Trigger click on corresponding pagination link
      }
    }
  }
}

function addDotPagination() {
  const preview = document.querySelector('.sproduct-gallery--preview');
  if (!preview) {
    return;
  }

  const windowWidth = window.innerWidth;
  if (windowWidth >= 1300) {
    return;
  }

  const thumbnails = document.querySelectorAll('.sproduct-gallery--thumbnails li');
  if (thumbnails.length <= 2) {
    return;
  }

  const paginationNav = document.createElement('nav');
  paginationNav.classList.add('sproduct-pagination'); // Add class 'sproduct-pagination' to the nav element

  const paginationLinks = [];

  thumbnails.forEach((_, index) => {
    const paginationLink = document.createElement('a');
   
    paginationLink.setAttribute('aria-label', `Go to slide ${index + 1}`);
    paginationLink.addEventListener('click', () => {
      handlePaginationClick(index);
      currentIndex = index; // Update currentIndex to match the clicked pagination index
    });

    paginationLinks.push(paginationLink);
    paginationNav.appendChild(paginationLink);
  });

  preview.appendChild(paginationNav);

  function handlePaginationClick(index) {
    thumbnails.forEach((thumbnail, i) => {
      const isActive = i === index;
      paginationLinks[i].classList.toggle('active', isActive);
    });
  }
}

function initializeGridClickFunctionality(gridSelector, itemSelector) {
  const grid = document.querySelector(gridSelector);

  if (grid) {
    const gridItems = grid.querySelectorAll(itemSelector);
    gridItems.forEach((item) => {
      const link = item.querySelector('a');
      if (link) {
        item.addEventListener('click', () => {
          window.location.href = link.href;
        });
      }
    });
  }
}

function AnnouncementBarInitialize() {
  const AnnouncementBar = document.querySelector('.announcement__bar');
  if (!AnnouncementBar) return;

  const messages = AnnouncementBarExtractMessages();
  if (messages.length > 0) {
    const announcementGroup = document.querySelector(".announcement__group");
    // Clear previous announcements if any
    announcementGroup.innerHTML = '';

    let cloneCount;
    let width;
    let animationDuration;

    // Determine the number of clones, width and animation duration based on screen width
    if (window.innerWidth > 1320) {
      cloneCount = 8;
      width = '12.5%';
      animationDuration = '40s';
    } else if (window.innerWidth <= 1320 && window.innerWidth > 992) {
      cloneCount = 6;
      width = '16.6666%';
      animationDuration = '30s';
    } else if (window.innerWidth <= 992 && window.innerWidth > 768) {
      cloneCount = 4;
      width = '25%';
      animationDuration = '20s';
    } else if (window.innerWidth <= 768) {
      cloneCount = 2;
      width = '50%';
      animationDuration = '10s';
    }

    // Clone messages up to cloneCount or trim excess
    let clonedMessages = messages.slice(0, cloneCount);
    while (clonedMessages.length < cloneCount) {
      clonedMessages = clonedMessages.concat(clonedMessages).slice(0, cloneCount);
    }

    // Create and append cloned announcement items
    clonedMessages.forEach(message => {
      const announcementItem = AnnouncementBarCreateItems(message, width);
      announcementGroup.appendChild(announcementItem);
    });

    // Apply animation duration
    announcementGroup.style.animationDuration = animationDuration;

    AnnouncementBarAnimate();
  }
	
  function handleResize() {
    // Reinitialize the announcement bar on resize
    AnnouncementBarInitialize();
  }

  // Debounce function to limit the rate at which a function can fire.
  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  // Set up the resize event with debounce
  const debouncedResize = debounce(handleResize, 250);
  window.addEventListener('resize', debouncedResize);

}

function AnnouncementBarExtractMessages() {
  const element = document.getElementById("jsonMessages");
  if (!element) return [];

  try {
    const data = JSON.parse(element.textContent || "[]");
    return data;
  } catch {
    return [];
  }
}

function AnnouncementBarCreateItems(message, width) {
  const announcementItem = document.createElement("div");
  announcementItem.classList.add("announcement__item");
  announcementItem.style.width = width;
  const messageParagraph = document.createElement("p");
  messageParagraph.textContent = message;
  announcementItem.appendChild(messageParagraph);
  return announcementItem;
}

function AnnouncementBarAnimate() {
  const announcementGroups = document.querySelectorAll(".announcement__group");
  announcementGroups.forEach(group => {
    group.style.opacity = "1";
    group.classList.add("is-animating");
  });
}

 function addDataStateToEmptyElements() {
    const okeStateElements = document.querySelectorAll('.js-oke-widgetSize');

    if (okeStateElements.length === 0) return;

      okeStateElements.forEach(okeStateElement => {
        if (okeStateElement.querySelector('.oke-state-empty')) {
          okeStateElement.setAttribute('data-state', 'empty');
        }
        okeStateElement.style.opacity = 1;
      });
  }

  function removeEmptyElements(selector) {
    if (!document.querySelector(selector)) return;

    const tabContents = document.querySelectorAll(selector);

    tabContents.forEach(tabContent => {
      const elements = tabContent.querySelectorAll('*');

      elements.forEach(element => {
        if (!element.innerHTML.trim() && element.tagName.toLowerCase() !== 'br') {
          element.remove();
        }
      });
    });
  }


  function addAltTextToImages() {
  try {
    const images = document.querySelectorAll('img');

    images.forEach(img => {
      if (!img.hasAttribute('alt') || img.getAttribute('alt').trim() === '') {
        img.setAttribute('alt', 'No description');
      }
    });
  } catch (error) {
    console.error('An error occurred while adding alt text to images:', error);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Check if the .ProductMeta element exists
  const productMeta = document.querySelector('.ProductMeta');
  const metaHeader = document.querySelector('.sproduct-meta--header');

  if (productMeta) {
    // Remove .ProductMeta from the DOM
    productMeta.remove();

    // Check if .sproduct-meta--header exists and apply padding-bottom: 0
    if (metaHeader) {
      metaHeader.style.paddingBottom = '.5rem';
    }
  }
});

function removeParagraphsInProductMetaTitles() {
  // Step 1: Find all .grid-items elements
  const gridItemsList = document.querySelectorAll('.grid-items');

  // Step 2: Loop through each .grid-items element
  gridItemsList.forEach((gridItems) => {
    // Step 3: Find all .product-meta__title elements inside the current .grid-items
    const productMetaTitles = gridItems.querySelectorAll('.product-meta__title');

    // Step 4: Loop through each .product-meta__title element
    productMetaTitles.forEach((productMetaTitle) => {
      // Step 5: Find the <p> and <span> inside the current .product-meta__title
      const paragraph = productMetaTitle.querySelector('p');
      const span = paragraph ? paragraph.querySelector('span') : null;

      if (span) {
        // Step 6: Check if the span text contains '/' separating words
        const spanText = span.textContent;
        if (spanText.includes('/') && /\//.test(spanText)) {
          // Step 7: Remove the <p> entirely if conditions are met
          paragraph.remove();
        }
      }
    });
  });
}

function removeEmptyParagraphsInGridHeaders() {
    const gridHeaders = document.querySelectorAll('.grid-header');
    if (gridHeaders.length > 0) {
        // Iterate through all <p> tags inside .grid-header elements
        gridHeaders.forEach(gridHeader => {
            const paragraphs = gridHeader.querySelectorAll('p');
            paragraphs.forEach(p => {
                // Check if the <p> tag is empty (no text content or children)
                if (p.textContent.trim() === '' && p.children.length === 0) {
                    p.remove();
                }
            });
        });
    }
}

function makeGridClickable() {
    // Select all .grid-clickable elements
    const gridClickables = document.querySelectorAll('.grid-clickable');

    // Check if any .grid-clickable elements exist
    if (gridClickables.length > 0) {
        gridClickables.forEach(grid => {
            const gridHeader = grid.querySelector('.grid-header');
            
            if (gridHeader) {
                const link = gridHeader.querySelector('a');

                // If an <a> tag exists in the .grid-header
                if (link) {
                    // Hide the .grid-header
                    gridHeader.style.display = 'none';

                    // Make the entire .grid-clickable element clickable
                    grid.addEventListener('click', () => {
                        window.location.href = link.href;
                    });

                    // Add a pointer cursor for better UX
                    grid.style.cursor = 'pointer';
                }
            }
        });
    }
}

// Call the function when needed
document.addEventListener('DOMContentLoaded', makeGridClickable);


document.addEventListener('DOMContentLoaded', function() {
  initializeProductGallery();
  setThumbnailsMaxHeight();
  window.addEventListener('resize', setThumbnailsMaxHeight);
  checkGalleryThumbnails();
  addDotPagination();
  addPreviewArrows();
  initializeGridClickFunctionality('[data-type-grid="col5"]', '.grid-item');
  initializeGridClickFunctionality('[data-type-grid="col1"]', '.grid-item');
  AnnouncementBarInitialize();
  addAltTextToImages();
  removeEmptyElements('.sproduct-tab--content');
  setTimeout(addDataStateToEmptyElements, 2500);
  removeParagraphsInProductMetaTitles();
  removeEmptyParagraphsInGridHeaders();
  makeGridClickable();
});

function closeCartOnOverlayClick() {
  const pageOverlay = document.querySelector('.PageOverlay');

  if (pageOverlay) {
    pageOverlay.addEventListener('click', function () {
      if (document.body.classList.contains('cart-open')) {
        const closeButton = document.querySelector('button[data-action="close-drawer"]');
        if (closeButton) {
          closeButton.click();
        }
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', closeCartOnOverlayClick);

document.addEventListener("DOMContentLoaded", () => {
  const playButtons = document.querySelectorAll("button.play-video");
  if (playButtons) {

  playButtons.forEach(button => {
    const parent = button.parentNode;
    const video = parent.querySelector("video");

    if (video) {
      button.addEventListener("click", () => {
        if (video.paused) {
          video.play();
          button.textContent = "Pause Video"; // Change text to "Pause Video"
          button.style.display = "none"; // Hide the button while video plays
        }
      });

      video.addEventListener("click", () => {
        if (video.paused) {
          video.play(); // Play the video if it's paused
          button.textContent = "Pause Video"; // Update button text
          button.style.display = "none"; // Hide the button while playing
        } else {
          video.pause(); // Pause the video if it's playing
          button.textContent = "Play Video"; // Update button text
          button.style.display = "block"; // Show the button while paused
        }
      });

      video.addEventListener("pause", () => {
        button.textContent = "Play Video";
        button.style.display = "block"; // Ensure button reappears when paused
      });

      video.addEventListener("play", () => {
        button.textContent = "Pause Video";
        button.style.display = "none"; // Hide the button while playing
      });
    }
  });    
  }
});

function updatePriceOnSelection() {
  // Check if there are radio buttons to monitor
  const radios = document.querySelectorAll('input[type="radio"].SizeSwatch__Radio');
  const selectDropdown = document.querySelector('select');

  // Check if there's a price element to update
  const priceElement = document.querySelector('[data-money-convertible], .product-price, .price');
  if (!priceElement) {
    console.log("No price element found.");
    return;
  }

  // Function to handle price updates
  function updatePrice(selectedValue) {
    // Simple check: if the value contains 'kr' or any currency symbol, it's considered a price
    if (/kr|€|\$|\£/.test(selectedValue)) {
      priceElement.textContent = selectedValue;
      console.log(`Price updated to: ${selectedValue}`);
    } else {
      console.log(`Non-monetary value selected: ${selectedValue}`);
    }
  }

  // Add event listener to each radio button (for price changes)
  radios.forEach((radio) => {
    radio.addEventListener('change', function(event) {
      const selectedPrice = event.target.value;
      updatePrice(selectedPrice);  // Call the function to update the price
    });
  });

  // Add event listener for select dropdown (for price changes)
  if (selectDropdown) {
    selectDropdown.addEventListener('change', function(event) {
      const selectedOption = event.target.selectedOptions[0].textContent;
      updatePrice(selectedOption);  // Call the function to update the price
    });
  }

  // Log that the function is active
  console.log("Price update function is now monitoring selections.");
}

document.addEventListener('DOMContentLoaded', updatePriceOnSelection);

function initializeGlobalAddToCartHandler() {
  const addToCartButtons = document.querySelectorAll('[data-variantid], [data-add-to-cart]');

  if (!addToCartButtons.length) {
    console.warn('[AddToCart] No add-to-cart buttons found.');
    return;
  }

  addToCartButtons.forEach(button => {
    button.addEventListener('click', async event => {
      event.preventDefault();

      const variantId = button.dataset.variantid || button.dataset.addToCart;
      if (!variantId) {
        console.warn('[AddToCart] Missing variant ID on button:', button);
        return;
      }

      document.body.style.cursor = 'progress';
      button.classList.add('is-adding');
      button.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        });

        if (!res.ok) throw new Error('Add to cart failed');

        await updateCartCountOnly();
        showToast('Item added to cart!');
      } catch (err) {
        console.error('[AddToCart] -', err);
        alert('Failed to add item to cart.');
      } finally {
        document.body.style.cursor = '';
        button.classList.remove('is-adding');
        button.disabled = false;
      }
    });
  });
}

async function updateCartCountOnly() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const cartCountEl = document.querySelector('.menu-cart-count');
    if (cartCountEl) {
      cartCountEl.textContent = `${cart.item_count}`;
    }
  } catch (err) {
    console.error('[CartUpdate] - Failed to update cart count:', err);
  }
}

function showToast(message) {
  let toast = document.createElement('div');
  toast.className = 'custom-toast';
  toast.textContent = message;

  document.body.appendChild(toast);

  setTimeout(() => {
    toast.classList.add('visible');
  }, 100);

  setTimeout(() => {
    toast.classList.remove('visible');
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

document.addEventListener('DOMContentLoaded', () => {
  initializeGlobalAddToCartHandler();
});


(() => {
  const body = document.body;
  let fixed = false;
  let ticking = false;

  const update = () => {
    const scrolled = window.scrollY >= 45;
    if (scrolled !== fixed) {
      body.classList.toggle('menu-fixed', scrolled);
      fixed = scrolled;
    }
    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  requestAnimationFrame(update);
})();
